export const MAINTENANCE_TASK_PERSONNEL_ASSIGNMENT_EXTERNAL_STAFF_NAME_FIELD_NAME =
  "name";
export const MAINTENANCE_TASK_PERSONNEL_ASSIGNMENT_EXTERNAL_STAFF_COMPANY_FIELD_NAME =
  "company";
export const MAINTENANCE_TASK_PERSONNEL_ASSIGNMENT_EXTERNAL_STAFF_RESPONSIBILITY_FIELD_NAME =
  "responsibility";
export const MAINTENANCE_TASK_PERSONNEL_ASSIGNMENT_INTERNAL_STAFF_DURATION_FIELD_NAME =
  "duration";
